import useCore from 'modules/reports/hooks/core'
import React from 'react'
import useStyles from './ReportsEditSearch.styles'

type Props = {}

function ReportsEditSearch(props: Props) {
  const classes = useStyles()
  const {p, pt} = useCore('reports', 'components', 'EditSearch')

  return (
    <div className={classes.root} data-testid={p('title')}>
      {pt('title')}
    </div>
  )
}

export default ReportsEditSearch
